import React, { Component } from 'react';
import { FormCheck } from 'react-bootstrap';

export class CustomHeader extends Component {
    render() {
        return (
            <>
                <FormCheck
                    id="toggleDetailed"
                    label="Detaljert visning"
                    checked={this.props.detailedView}
                    inline={true}
                    onChange={this.props.onDetailedViewToggle}
                    className={!this.props.showDetailedView ? 'hidden' : ''} />
                <FormCheck
                    id="toggleScrapDeposit"
                    label="Inkluder vrakpant"
                    checked={this.props.incScrapDeposit}
                    inline={true}
                    onChange={this.props.onScrapDepositToggle} />
            </>
        )
    }
}
